import { InlineCard } from "components/DynamicComponent/atoms/InlineCards"
import CallToAction from "components/CallToAction"
import { getStoryblokLink } from "utilities/getStoryblokLink"
import getTelLink from "utilities/getTelLink"
import richText from "utilities/richText"

export default function LocationLinks({ blok }) {
  return (
    <section className="py-12">
      <div className="max-w-screen-xl mx-auto px-8">
        {blok?.title ? <h2 className="text-m2 pb-8">{blok.title}</h2> : null}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-12">
          {blok.locations.map((card) => (
            <InlineCard
              title={`${card.name}${card?.facility && card.facility !== "" ? ` ${card.facility}` : ""}`}
              link={card.slug}
              key={card.name}
            >
              {richText(card.address)}
              <CallToAction href={getStoryblokLink(card.directionsLink)} style="map-pin">
                Get Directions
              </CallToAction>
              <CallToAction href={getTelLink(card.phone)} style="phone">
                {card.phone}
              </CallToAction>
            </InlineCard>
          ))}
        </div>
      </div>
    </section>
  )
}
